import React from 'react';

const UserFirstExperienceSection = ({
    title = "Empowering Enterprises with Intelligent Automation",
    description = "At Mobikode, we help forward-thinking enterprises unlock the full potential of Artificial Intelligence (AI) and Intelligent Automation. Our solutions go beyond basic automation to deliver proactive, scalable, and secure AI systems that transform the way businesses operate, engage, and grow."
}) => {
    return (
        <section className="w-full pt-16 lg:pt-[100px] bg-white overflow-hidden relative">
            <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                {/* Mobile me flex-col (stacked) aur desktop me flex-row (side-by-side) rakha gaya hai. Fixed height sirf lg screens ke liye. */}
                <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">

                    {/* Image Box: Mobile pe relative aur fix height (250px), Desktop pe absolute right */}
                    <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                        <img
                            src="/assets/work/img2.png"
                            alt="ai automation"
                            className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                        />
                    </div>
                    <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[750px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">

                        <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                            {title}
                        </h3>
                        <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-[500] font-graphik text-justify">
                            {description}
                        </p>
                        <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                        <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                    </div>

                </div>
            </div>
        </section>
    );
};

export default UserFirstExperienceSection;